import {
  Currency,
  IntervalType,
  PlanId,
} from 'domains/models/subscription/planId';
import { PlanVersion } from 'domains/models/subscription/planVersion';
import { TrialChannel } from 'domains/models/subscription/trial_channel';
import { z } from 'zod';

export const CurrencyEnum = z.nativeEnum(Currency);
export const IntervalTypeEnum = z.nativeEnum(IntervalType);
export const PlanIdEnum = z.nativeEnum(PlanId);
export const PlanVersionEnum = z.nativeEnum(PlanVersion);
export const TrialChannelEnum = z.nativeEnum(TrialChannel);
